import { render } from "./App.vue?vue&type=template&id=0e363bae"
const script = {}

import exportComponent from "/Users/jk/moen-digital-service-status/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__